import {
  LogLevel,
  BrowserUtils,
  type Configuration,
} from '@azure/msal-browser';

export const b2cPolicies = {
  names: {
    signIn: `${import.meta.env.VITE_B2C_SIGN_IN_POLICY}`,
  },
  authorities: {
    signIn: {
      authority: `https://${import.meta.env.VITE_B2C_AUTHORITY_DOMAIN}/${import.meta.env.VITE_B2C_TENANT_ID}/${import.meta.env.VITE_B2C_SIGN_IN_POLICY}`,
    },
  },
  authorityDomain: `${import.meta.env.VITE_B2C_AUTHORITY_DOMAIN}`,
};

export const msalConfig: Configuration = {
  auth: {
    clientId: `${import.meta.env.VITE_B2C_CLIENT_ID}`,
    authority: b2cPolicies.authorities.signIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: '/redirect',
    postLogoutRedirectUri: '/',
    onRedirectNavigate: () => !BrowserUtils.isInIframe(),
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    allowPlatformBroker: false,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ['openid', 'offline_access', `${import.meta.env.VITE_B2C_API_SCOPE}`],
  extraQueryParameters: {
    tenant: `${import.meta.env.VITE_B2C_TENANT}`,
    country: `${import.meta.env.VITE_B2C_COUNTRY}`,
    locale: 'de-de', // Sets the language for email communication.
    'ui-locales': 'de-de', // Sets the language for the Azure AD B2C UI template.
    salesChannel: `${import.meta.env.VITE_B2C_SALES_CHANNEL}`,
    partner: `${import.meta.env.VITE_B2C_PARTNER}`,
    brand: 'marketplace', // Will customize the template ( logo, email, agb)
  },
};
